import { render, staticRenderFns } from "./viewQuote.vue?vue&type=template&id=01a04d7c&"
import script from "./viewQuote.vue?vue&type=script&lang=js&"
export * from "./viewQuote.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports